import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../modules/auth/auth.service';
import { AuthenticationService } from '../modules/shared/services/authentication.service';

@Component({
    selector: 'app-access-denied',
    templateUrl: 'access-denied.component.html',
    styleUrls: ['access-denied.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AccessDeniedComponent {

  constructor(
    private router: Router,
    private authService: AuthService,
    private authenticationService: AuthenticationService
  ) {}

  goToMyTrack(): void {
    const account = this.authenticationService.getCurrentAccount();
    if (account && account.accountUID) {
      void this.router.navigate([`/${account.accountUID}/mytrack/planning`]);
    }
  }

  logout(): void {
    this.authService.logout();
  }
}
